import styled from "styled-components";

import { FlexDiv, SVGSprite } from "../../../Atoms";
import { SubmitButton } from "../../FormInputs";

import Typography from "../../../../foundation/Typography/V2";

import { FormFieldBox } from "../../FormWrapper/style";

export const FormTitleContainer = styled(FlexDiv)`
  flex-direction: column;
  padding: 8px;
`;

export const StyledTitle = styled(Typography)`
  color: ${({ theme }) => theme?.colorsV2?.shyft?.purple_text};
`;

export const StyledSubtitle = styled(Typography)`
  color: ${({ theme }) => theme?.colorsV2?.blueGray?.shade_800};
`;

export const StyledFormFieldBox = styled(FormFieldBox)`
  ${({ theme }) => `
    padding: 40px 32px;
    border-radius: 16px;
    background-color: ${theme.colors.white};
    border: 1px solid ${theme.colorsV2.gray.shade_200};
    box-shadow: 0px 0px 6px
        rgba(${theme.colors.shadows.black}, 0.02),
      0px 2px 4px rgba(${theme.colors.shadows.black}, 0.08);
  `}
  .date-picker svg {
    right: 16px;
  }
  @media only screen and (max-width: 767px) {
    border: none;
    padding: 40px 8px;
    margin: 0 16px 64px;
  }
`;

export const NameEmailWrapper = styled(FlexDiv)`
  gap: 8px;
  > div {
    flex: 1;
  }
  @media only screen and (max-width: 767px) {
    flex-direction: column;
  }
`;

export const Label = styled(Typography)`
  color: ${({ theme }) => theme.colorsV2.gray.shade_500};
  margin-bottom: 8px;
`;

export const PaymentIcon = styled(SVGSprite)`
  height: 24px;
  width: 24px;
  stroke: ${({ theme }) => theme.colors.white};
  margin-right: 16px;
`;

export const StyledSubmitButton = styled(SubmitButton)`
  button {
    padding: 16px 48px;
    color: ${({ theme }) => theme.colorsV2.gray.shade_700};
  }
`;

export const StartDateWrapper = styled(FlexDiv)`
  flex-direction: column;
  @media only screen and (max-width: 1079px) {
    max-width: unset;
  }
`;
